import http from "../../http-common";

class NotifyTeacherService {
    searchNotifyTeacher(pageNumber, maxPageItem, active, dateList, title, content, scope) {
        return http.get(`/notify-teacher/search?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&active=${active}&dateList=${dateList}&title=${title}&content=${content}&scope=${scope}`);
    }

    checkNewConfigCount() {
        return http.get(`/notify-teacher/newsConfig/count`);
    }

    findByNotifyTeacher(id) {
        return http.get(`/notify-teacher/detail/${id}`);
    }

    getActiveNotifyTeacher(data) {
        return http.put("/notify-teacher/active", data);
    }

    getApprovedNotifyTeacher(data) {
        return http.put("/notify-teacher/approved", data);
    }

    createNotifyTeacher(data) {
        return http.post("/notify-teacher/create", data);
    }

    updateNotifyTeacher(data) {
        return http.put("/notify-teacher/update", data);
    }

    deleteNotifyTeacher(id) {
        return http.delete(`/notify-teacher/delete/${id}`);
    }

    setPinPost({ id, pin, endPinDate }) {
        return http.post(`/notify-teacher/pin`, { id, pin, endPinDate });
    }
}

export default new NotifyTeacherService();
